import angular from 'angular'
import {
    company
} from 'redevConfig'


const info = (company && company.info) || ''

const orgDetailPage = info ? require(`redevelopment/system/org/${info.templateName}`) : require('../org/view/orgDetail.html')

function configRouter($stateProvider) {
    $stateProvider.state(
        'system.syssetting.company', 
        {
            abstract: true,
            url: '/company',
            template: '<div ui-view></div>',
            title: '企业信息',
            default: 'system.syssetting.company.info',
        }    
    )
    $stateProvider.state(
        'system.syssetting.company.info', 
        {
            url: '/info',
            template: orgDetailPage,
            controller: 'orgDetailCtrl',
        }    
    )
}

export default angular
    .module('system.syssetting.company', [])
    .config(['$stateProvider', configRouter])
    .name



// WEBPACK FOOTER //
// ./src/app/system/systemsetting/company/index.js